import { unities } from "@/common/constants/unities.constants";
import { ClientConsumptionData } from "@/common/types/client/consumption.type";
import { formatCurrency, formatDecimal, formatUnit } from "@/common/utils/formatters";

type ConsumptionEventableProps = {
  data: ClientConsumptionData;
};

const ConsumptionDetails = ({ data: consumption }: ConsumptionEventableProps) => {

  return (
    <div className="flex flex-col gap-3">
      <div className='flex gap-2'>
        <p className="italic">Empresa cliente:</p>
        <p className='font-bold'>{consumption?.presented_client_fantasy_name || '--'}</p>
      </div>

      {Number(consumption?.line_items?.length) > 0 && (
        <div className="flex flex-col justify-center">
          {consumption?.line_items?.map((line_item) => {
            // WARN: We are here changing the logic to priorize the original price over the real total amount,
            // actually, when the original price/total is present, we are hiding the actual price/total and subtracting of the fee,
            // the difference between the two numbers. This is being made for companies that has dynamic price and dont want to know that this
            // price that is being applied as a fee
            const hasOriginalUnitPrice = line_item.original_unit_price !== null && line_item.original_unit_price !== undefined
            const unitPrice = hasOriginalUnitPrice
              ? Number(line_item.original_unit_price)
              : Number(line_item.amount) / Number(line_item.quantity)

            return (
              <p key={line_item.id}>
                {line_item.product.display_name} - {formatUnit(formatDecimal(line_item.quantity, 3), line_item.product.unit_for_quantity)} - {formatCurrency(unitPrice)}/{unities[line_item.product.unit_for_quantity]}
              </p>
            )
          })}
        </div>
      )}
    </div>
  );
};

export default ConsumptionDetails;
